import { render, staticRenderFns } from "./submitType.vue?vue&type=template&id=8d1d5a26&scoped=true&"
import script from "./submitType.vue?vue&type=script&lang=js&"
export * from "./submitType.vue?vue&type=script&lang=js&"
import style0 from "./submitType.vue?vue&type=style&index=0&id=8d1d5a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1d5a26",
  null
  
)

export default component.exports